/* ------------------------------------------------------------------------------
*	Utils string
*	by: Brent Ayers ~ axb1525
*
*	Purpose:
*		- Performs utility functions for url string manipulation
*	To Do:
*
*
* ------------------------------------------------------------------------------ */

(function closure(root, factory) {
	if (typeof define === 'function' && define.amd) {
		define(['jquery', 'cookie-utils'], function load(jQuery, cookieUtils) {
			return factory(root, jQuery, cookieUtils);
		});
	} else {
		/*eslint-disable*/
		root['utilsUrl'] = factory(root, jQuery, cookieUtils);
		/*eslint-enable*/
	}
})(this, function factory(root, $, cookieUtils) {
	var _utils = {};
	var defaults = {
		url: window.location.href,
		lookupParm: false,
		setParms: [],
		addHost: true
	};

	/**
	 * @function - normalizes querystring
	 * @returns {string} querystring in 'bob=val1&name2=val3' format
	 * @param {string} url string to be manipulated
	 */

	var getParamStr = function getParamStr(_url) {
		var url = (typeof _url !== 'undefined')
			? _url
			: defaults.url;
		// remove host name - split may prove more reliable
		if (url.indexOf('?') > -1) {
			url = url.match(/(\?.*)/)[0];
		} else {
			return false;
		}
		// remove ?
		url = url.replace(/^\?/, '');
		// remove hash
		url = url.split('#')[0];

		return url;
	};

	/**
	 * @function - gets url params of string, or current url
	 * @returns {object|string} if nothing passed for lookupParm, returns object list of qeury params or string of requested parameter
	 * @param {string} url default is window.location.href
	 * @param {string} lookupParm paramaters to be returned
	 */
	var getUrlParms = function getUrlParms(args) {
		var queryArr = [];
		var currParam = [];
		var tempObj = {};
		var valFound = false;
		var key;
		var val;
		var i;
		var opts = $.extend({}, defaults, args);

		// remove host name, and hash
		opts.url = getParamStr(opts.url);
		if (opts.url) {
			queryArr = opts.url.split('&');

			for (i = 0; i < queryArr.length; i++) {
				currParam = queryArr[i].split('=');
				if (currParam[0] === opts.lookupParm) {
					// found param
					valFound = currParam[1];
				} else {
					key = currParam[0];
					val = decodeURIComponent(currParam[1]);
					tempObj[key] = val;
				}
			}
		}
		if (opts.lookupParm) {
			// returns either lookup val or false if nothing found
			return valFound;
		}
		return tempObj;
	};

	/**
	 * @function - sets url params of string, or current url
	 * @returns {string} if nothing passed for lookupParm, returns object list of qeury params or string of requested parameter
	 * @param {string} url default is window.location.href
	 * @param {string} setParms paramaters to be added/updated
	 */
	var setUrlParms = function setUrlParms(args) {
		var oldParms = {};
		var tempParms = {};
		var newUrl = '';
		var delim = '';
		var firstParm = true;
		var hash = '';
		var i;
		var opts = $.extend({}, defaults, args);

		newUrl = (opts.addHost) ? opts.url.split('?')[0] + '?' : '';

		newUrl = newUrl.split('#');

		hash = (typeof newUrl[1] !== 'undefined')
			? '#' + newUrl[1].replace('?', '')
			: '';

		newUrl = (newUrl[0].indexOf('?') === -1)
			? newUrl[0] + '?'
			: newUrl[0];

		oldParms = getUrlParms(opts);

		// combine old and new parameters
		tempParms = $.extend({}, oldParms, opts.setParms);


		for (i in tempParms) {
			// sometimes a param is set with no value, need to make sure it doesn't come back as 'undefined'
			if (tempParms.hasOwnProperty(i)) {
				tempParms[i] = (tempParms[i] === 'undefined') ? '' : '=' + encodeURIComponent(tempParms[i]);
				if (tempParms[i] !== '=null') {
					newUrl += delim + i + tempParms[i];

					if (firstParm) {
						delim = '&';
						firstParm = false;
					}
				}
			}
		}
		return newUrl + hash;
	};


	function isLocalStoreTab(defstore, paramLocStore) {
		var startIdx;
		var afterLocStore;
		var endIdx;
		var stopIdx;
		var locStore;

		var url = window.location + '';
		// no local store number in the url
		if (url.indexOf(paramLocStore) === -1) {
			return false;
		} else if (url.indexOf(paramLocStore) > -1) {
			startIdx = url.indexOf(paramLocStore);
			afterLocStore = url.substring(startIdx);
			endIdx = afterLocStore.indexOf('=');
			stopIdx = afterLocStore.indexOf('&');
			locStore;
			if (stopIdx > 0) {
				locStore = afterLocStore.substring(endIdx + 1, stopIdx);
			} else {
				locStore = afterLocStore.substring(endIdx + 1);
			}
			if (defstore !== locStore) {
				return true;
			}
		} else if (cookieUtils.readCookie('THD_BROWSESTATUS') === '1') {
			return true;
		}
		return false;
	}

	_utils.Url = {
		/* naming Strings to prvent any reserved word conflicts */
		get: function get(args) {
			return getUrlParms(args);
		},
		set: function set(args) {
			return setUrlParms(args);
		},
		isLocalStoreTab: isLocalStoreTab

	};

	return _utils.Url;
});
